'use client';

import React, { useState } from 'react';
import { useTranslations } from '../../../../contexts/translation.context';
import { RevshareAccount } from '../types';
import SfsActivityModal from './SfsActivityModal';

interface SummaryCellProps {
  account: RevshareAccount;
}

const SummaryCell: React.FC<SummaryCellProps> = ({ account }) => {
  const { t } = useTranslations();
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="flex flex-col gap-1 py-2">
      <button
        onClick={() => setIsModalOpen(true)}
        className="text-sm text-partner text-left cursor-pointer bg-transparent border-none p-0"
      >
        {t('partner.revshare.accounts.sfsModal.sfsActivity')}
      </button>
      <div className="text-sm text-auth-muted leading-4">
        <span>{t('partner.partnerAccounts.campaigns')}:</span>{' '}
        <span className="text-partner font-semibold">{account.campaigns_count ?? 0}</span>
      </div>
      {/* <div className="flex items-center gap-1 text-sm text-auth-muted">
        <span>{t('partner.partnerAccounts.income')}:</span>
        <span className="text-auth-ink text-sm font-semibold leading-4">{formatCurrency(account.income)}</span>
      </div>
      <div className="flex items-center gap-1 text-sm text-auth-muted">
        <span>{t('partner.partnerAccounts.expected')}:</span>
        <span className="text-success text-sm font-semibold leading-4">+{formatCurrency(account.pending_income)}</span>
      </div> */}

      <SfsActivityModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        accountName={account.of_user_name || account.name}
        ofModelId={account.of_user_id}
      />
    </div>
  );
};

export default SummaryCell;
